module.exports = __webpack_public_path__ + "static/media/insitu_reb.6ade7d20.png";